import React, {Fragment, useCallback} from "react";
import {Controller} from "react-hook-form";
import {SmartErrorDiv} from "root/ReactHookForm/FormComponents/SmartErrorDiv";
import ReactQuill from "react-quill-new";
import 'react-quill-new/dist/quill.snow.css';

const FormInputRichText = ({ heading, name, sectionName, validate, control, maxLength = 1024, formErrors, readOnly = false, toolbarOptions = [[{ 'header': [1, 2, false] }]] }) =>
{

    const elementName = sectionName === undefined ? name : sectionName + '.' + name ;

    // We need to cache this function, otherwise the quill components will re-render empty
    // when a render occurs
    const handleTab = useCallback((range,context) => {
        return true ;
    }, []);

    const modules = {
        toolbar: toolbarOptions,
        keyboard: {
            bindings: {
                'tab': {
                    key: 9,
                    handler: handleTab
                }
            }
        }
    }

    return (
        <Fragment key={elementName}>
            { heading !== null && <label>{heading}</label> }
            <Controller
                control={control}
                name={elementName}
                defaultValue={[]}
                rules={{ required: false, validate: validate}}
                render={({ field: { onChange, value, name, ref },
                             fieldState: { invalid, isTouched, isDirty, error },
                             formState,
                         }) => <ReactQuill key={'q' + elementName} readOnly={readOnly} theme="snow"  modules={modules} value={value} onChange={onChange} height='200px' />}
            />
            <SmartErrorDiv sectionName={sectionName}  name={name} maxLength={maxLength} formErrors={formErrors} />
        </Fragment>
    )
}

export default FormInputRichText;
